import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import {
  PhosphateLegalNorm,
  GetPhosphateLegalNormsResponse,
  UpsertPhosphateLegalNormResponse,
  PhosphateLegalNormFilter,
  DeletePhosphateLegalNormResponse,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class PhosphateLegalNormApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/field-report/secure/phosphatelegalnorm';

  getPhosphateLegalNorms(pageNumber: number, pageSize: number, filter: PhosphateLegalNormFilter): Observable<GetPhosphateLegalNormsResponse> {
    let url = `${this.baseUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (filter.year) {
      url += `&calendarYear=${filter.year}`;
    }
    return this.http.get<GetPhosphateLegalNormsResponse>(url);
  }

  upsertPhosphateLegalNorm(phosphateLegalNorm: PhosphateLegalNorm) {
    return this.http.post<UpsertPhosphateLegalNormResponse>(this.baseUrl, phosphateLegalNorm, {});
  }

  deletePhosphateLegalNorm(phosphateLegalNormId: number) {
    return this.http.delete<DeletePhosphateLegalNormResponse>(this.baseUrl + '/' + phosphateLegalNormId);
  }
}
